import { Outlet } from 'react-router';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { useSidebar } from '../hooks/useSidebar';
import { useLiveEvents } from '../hooks/useLiveEvents';
import { useSession } from '../features/session/useSession';
import { useIdleLogout } from '../features/session/useIdleLogout';
import { ActionRequiredGuard } from '../features/onboarding/ActionRequiredGuard';
import { cn } from '../lib/cn';

/** Owns the liveUpdated subscription so SSE payloads do not re-render the shell. */
function LiveEventsBridge() {
  const { me } = useSession();
  useLiveEvents(me?.currentScope?.id);
  return null;
}

export function AppShell() {
  const sidebar = useSidebar();
  useIdleLogout();

  const handleNavigate = () => {
    if (sidebar.isMobile) sidebar.closeMobile();
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <LiveEventsBridge />
      <Sidebar
        collapsed={sidebar.collapsed}
        isMobile={sidebar.isMobile}
        mobileOpen={sidebar.mobileOpen}
        onToggleCollapsed={sidebar.toggleCollapsed}
        onNavigate={handleNavigate}
      />

      <div
        className={cn(
          'flex min-h-screen flex-col transition-[padding] duration-200',
          !sidebar.isMobile && (sidebar.collapsed ? 'md:pl-20' : 'md:pl-64'),
        )}
      >
        <Topbar onOpenMobile={sidebar.toggleMobile} />
        <main className="flex-1 px-4 py-6 lg:px-6 lg:py-8">
          <ActionRequiredGuard>
            <Outlet />
          </ActionRequiredGuard>
        </main>
      </div>
    </div>
  );
}
